import { render, staticRenderFns } from "./InvoicingInformation.vue?vue&type=template&id=20bf9099&scoped=true"
import script from "./InvoicingInformation.vue?vue&type=script&lang=js"
export * from "./InvoicingInformation.vue?vue&type=script&lang=js"
import style0 from "./InvoicingInformation.vue?vue&type=style&index=0&id=20bf9099&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bf9099",
  null
  
)

export default component.exports